import React, { useState, useMemo, useEffect, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/esm/Button';
import FormCustom from '../../Components/Form/FormCustom';
import Input from '../../Components/Form/Input';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import TextArea from '../../Components/Form/TextArea';
import Select from '../../Components/Form/Select';
import Loading from '../../Components/Layout/Styled/Loading';

const BotLeads = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [workers, setWorkers] = useState([])
    const [showLoading, setShowLoading] = useState(false)

    const [dataFilter, setDataFilter] = useState({
        p_date_start: Helpers.date.get({
            format: '%Y-%m-%d',
            addDays: -7
        }),
        p_date_end: Helpers.date.get({
            format: '%Y-%m-%d'
        })
    })

    /* const [reporte, setReport] = useState({}) */

    const [showAlert, setShowAlert] = useState(false);
    const [data, setData] = useState({
        p_observation: '',
        p_id_worker: '',
        p_id_bot_lead: '',
        loadSubmit: false,
        hide: _ => setShowAlert(false)
    })

    const getData = _ => {
        setIsProccesing(true)
        Controllers.bot.get_leads({
            ...dataFilter
        }).then(res => {
            setRows(res.data.records)
            /* setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            }) */
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    useEffect(() => {
        getData()
    }, [])

    const markAsContacted = _ => {
        if (!data.p_id_worker) {
            Helpers.toast.construct({ response: 'warning', message: 'Seleccione el usuario que contactó', toast })
            return
        }

        if (!data.p_observation) {
            Helpers.toast.construct({ response: 'warning', message: 'Ingrese la observación', toast })
            return
        }

        setData({
            ...data,
            loadSubmit: true
        })

        Controllers.bot.bot_lead_mark_as_contacted(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowAlert(false)
                getData()
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(_ => {
                setData({
                    ...data,
                    loadSubmit: false
                })
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                {
                    name: 'id_bot_lead', text: 'ID', align: 'center'
                },
                { name: 'created_at', text: 'Fecha', align: 'center' },
                { name: 'conversation_id', text: 'Telefono', align: 'center' },
                {
                    name: 'share_data', text: 'Aceptó compartir datos', align: 'center', render: r => {
                        return <div className={'badge badge-' + (parseInt(r.share_data) === 1 ? 'success' : 'warning')}>
                            {parseInt(r.share_data) === 1 ? 'Si' : 'No'}
                        </div>
                    }
                },
                { name: 'name_bot', text: 'Nombre', align: 'center' },
                { name: 'customer_id_bot', text: 'ID Cliente', align: 'center' },
                {
                    name: 'was_contacted', text: '', align: 'center', render: r => {
                        if (parseInt(r.was_contacted) === 1) {
                            return <div className="d-flex flex-column">
                                <div className='badge badge-success align-self-center mb-2'>Contactado</div>
                                <div className=''>{r.name_worker}</div>
                            </div>
                        }

                        return <Button size="xs" variant="primary" onClick={_ => {
                            setShowLoading(true)
                            Controllers.worker.get_workers_public_by_profile({
                                p_id_profile: 6, // Call Center
                            }).then(res => {
                                setWorkers(res.data)
                                setData({
                                    ...data,
                                    p_id_bot_lead: r.id_bot_lead,
                                    p_observation: '',
                                    p_id_worker: '',
                                })
                                setShowAlert(true)
                                setShowLoading(false)
                            })
                        }
                        }>
                            <i className="fa fa-check mr-2"></i> Marcar como contactado
                        </Button>
                    }
                },
                { name: 'observation', text: 'Observaciones', align: 'center' },
            ],
        ]}
        columnOrder="id_bot_lead"
        orderDirection="desc"
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    const cboWorker = useCallback(() => {
        if (!data.p_id_worker) {
            return ''
        }

        const find = workers.find(r => r.id_worker === data.p_id_worker)

        if (!find) {
            return ''
        }

        return {
            value: find.id_worker,
            label: find.name_worker + ' ' + find.last_name_worker
        }
    }, [data.p_id_worker, workers])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Bot Leads</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                    getData()
                }}>
                    <Input
                        classNameParent="col-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Inicio"
                        text="Fecha Inicio"
                        value={dataFilter.p_date_start}
                        onChange={e => setDataFilter({ ...dataFilter, p_date_start: e.currentTarget.value })}
                        required
                        type="date"
                    />
                    <Input
                        classNameParent="col-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Fina"
                        text="Fecha Fina"
                        value={dataFilter.p_date_end}
                        onChange={e => setDataFilter({ ...dataFilter, p_date_end: e.currentTarget.value })}
                        append={[<Button type="submit">
                            <i className="fa fa-search mr-2"></i>Buscar
                        </Button>]}
                        required
                        type="date"
                    />
                </FormCustom>
                {/* reporte?.filename ? <div className='mb-4'>
                    <a href={reporte?.excel} download={reporte?.filename}>
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                </div> : '' */}
                {dtRows}
            </Card.Body>
        </Card>
        <Loading show={showLoading}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
        <SweetAlert
            icon="approve"
            iconClassName="fas fa-check text-primary"
            show={showAlert}
            showCancelButton
            title={<>¿Marcar como contactado?</>}
            subtitle={<>#{data.p_id_bot_lead}</>}
            confirmButtonText="¡Sí, marcar!"
            cancelButtonText="¡No, cancelar!"
            loadSubmit={data.loadSubmit}
            onCancel={data.hide}
            onConfirm={markAsContacted}
            content={_ => {
                return <>
                    <Select
                        icon="fa fa-user"
                        text="Usuario que contactó"
                        classNameParent="col-md-12 mb-2"
                        options={workers.map(r => {
                            return {
                                value: r.id_worker,
                                label: r.name_worker + ' ' + r.last_name_worker
                            }
                        })}
                        onChange={e => {
                            setData({
                                ...data,
                                p_id_worker: e.value
                            })
                        }}
                        value={cboWorker()}
                    />
                    <TextArea
                        text="Observaciones"
                        placeholder="Observaciones"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        onChange={e => {
                            setData({
                                ...data,
                                p_observation: e.currentTarget.value
                            })
                        }}
                        rows="5"
                    />
                </>
            }}
        />
    </>
}

export default BotLeads